import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import classNames from 'classnames';
import { FW_PREFIX } from '../../shared/constants/generalConstants.js';
import { IlIcon } from '../IlIcon/index.js';
import { getTranslations } from '../../shared/localization/languageMap.js';

var IlPaginationV2 = /*#__PURE__*/function (_Component) {
  function IlPaginationV2(props) {
    var _this;
    _classCallCheck(this, IlPaginationV2);
    _this = _callSuper(this, IlPaginationV2, [props]);
    _defineProperty(_this, "setPage", function (event) {
      var increment = event.currentTarget.dataset.pageIncrement;
      var page = _this.state.page;
      if (increment) {
        page = Number(page) + Number(increment);
      } else {
        page = Number(event.currentTarget.value);
      }
      _this.setState({
        page: page
      });
      _this.props.onChange({
        page: page,
        pageSize: _this.state.pageSize
      });
    });
    _defineProperty(_this, "setPageSize", function (event) {
      var pageSize = Number(event.currentTarget.value);
      _this.setState({
        page: 1,
        pageSize: pageSize
      });
      _this.props.onChange({
        page: 1,
        pageSize: pageSize
      });
    });
    var defaultPage = 1;
    var defaultPageSize = props.pageSizes[0];
    _this.state = {
      page: _this.props.page || defaultPage,
      pageSize: _this.props.pageSize || defaultPageSize
    };
    return _this;
  }
  _inherits(IlPaginationV2, _Component);
  return _createClass(IlPaginationV2, [{
    key: "t",
    value: function t(key, args) {
      var defaultString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var locale = document.documentElement.lang || 'en';
      var source = getTranslations(locale);
      var localizedText = source.pagination[key];
      var translation = defaultString;
      if (this.props.i18n && this.props.i18n[locale] && this.props.i18n[locale][key]) {
        translation = this.props.i18n[locale][key];
      } else if (localizedText) {
        translation = localizedText;
      }
      return translation.replace(/{(\w+)}/g, function (match, matchKey) {
        return args[matchKey] !== undefined ? args[matchKey] : match;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var newState = {};
      if (this.props.page !== prevProps.page) {
        newState.page = this.props.page;
      }
      if (this.props.pageSize !== prevProps.pageSize) {
        newState.pageSize = this.props.pageSize;
      }
      if (Object.keys(newState).length) {
        this.setState(newState);
      }
    }
  }, {
    key: "getTotalPages",
    value: function getTotalPages() {
      return Math.ceil(this.props.totalItems / this.state.pageSize);
    }
  }, {
    key: "getPageNumbers",
    value: function getPageNumbers() {
      return Array.from({
        length: this.getTotalPages()
      }, function (member, index) {
        return index + 1;
      });
    }
  }, {
    key: "getItemRangeText",
    value: function getItemRangeText() {
      var startItem = (this.state.page - 1) * this.state.pageSize + 1;
      var endItem = Math.min(startItem + this.state.pageSize - 1, this.props.totalItems);
      if (this.props.pagesUnknown) {
        if (this.props.itemText) {
          return this.props.itemText(startItem, endItem);
        } else {
          return '';
        }
      } else {
        return this.t('itemRangeText', {
          start: startItem,
          end: endItem,
          total: this.props.totalItems
        });
      }
    }
  }, {
    key: "getPageRangeText",
    value: function getPageRangeText() {
      return this.props.pagesUnknown ? '' : this.t('pageRangeText', {
        // the current page token is passed for the benefit of third party translators
        // the actual current page is only shown in the dropdown control
        current: '',
        total: this.getTotalPages()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var baseClass = "".concat(FW_PREFIX, "__pagination");
      var className = classNames(baseClass, this.props.className);
      return /*#__PURE__*/React__default.createElement("div", {
        className: className
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(baseClass, "-left")
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "".concat(baseClass, "-select-label"),
        htmlFor: "".concat(FW_PREFIX, "-page-size-select")
      }, this.t('itemsPerPageText')), /*#__PURE__*/React__default.createElement("select", {
        id: "".concat(FW_PREFIX, "-page-size-select"),
        className: "".concat(baseClass, "-select"),
        onChange: this.setPageSize,
        value: this.state.pageSize
      }, this.props.pageSizes.map(function (size) {
        return /*#__PURE__*/React__default.createElement("option", {
          value: size,
          key: size
        }, size);
      })), /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-arrows-down",
        className: "".concat(baseClass, "-select-icon")
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "".concat(baseClass, "-item-count"),
        "aria-live": "polite",
        "aria-atomic": "true",
        "aria-relevant": "all"
      }, this.getItemRangeText())), /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(baseClass, "-right")
      }, /*#__PURE__*/React__default.createElement("select", {
        id: "".concat(FW_PREFIX, "-page-select"),
        className: "".concat(baseClass, "-select"),
        "aria-label": this.t('pageNumberText'),
        value: this.state.page,
        onChange: this.setPage,
        disabled: this.getTotalPages() < 2
      }, this.getPageNumbers().map(function (pageNumber) {
        return /*#__PURE__*/React__default.createElement("option", {
          value: pageNumber,
          key: pageNumber
        }, pageNumber);
      })), /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-arrows-down",
        className: "".concat(baseClass, "-select-icon")
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "".concat(baseClass, "-page-count")
      }, this.getPageRangeText()), /*#__PURE__*/React__default.createElement("button", {
        className: "".concat(baseClass, "-button"),
        "data-page-increment": "-1",
        type: "button",
        onClick: this.setPage,
        disabled: this.state.page === 1,
        "aria-label": this.t('backwardText')
      }, /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-arrows-left",
        className: "".concat(baseClass, "-button-icon")
      })), /*#__PURE__*/React__default.createElement("button", {
        className: "".concat(baseClass, "-button"),
        "data-page-increment": "1",
        type: "button",
        onClick: this.setPage,
        disabled: this.state.page === this.getTotalPages(),
        "aria-label": this.t('forwardText')
      }, /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-arrows-right",
        className: "".concat(baseClass, "-button-icon")
      }))));
    }
  }]);
}(Component);

export { IlPaginationV2, IlPaginationV2 as default };
